<template>
   <card>
      <template slot="header">
         <div class="row">
            <div class="col-md-2">
               <h3 class="card-title">Departments</h3>
            </div>
         </div>
      </template>
      <div class="row">
         <div class=" col-md-6">
            <nav class="row">
               <ol class="breadcrumb arr-right bg-breadcrum">
                  <li class="breadcrumb-item">
                     <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                  </li>
                   <li class="breadcrumb-item active">Departments</li>
                   <li class="breadcrumb-item">
                       <router-link to="subdepartment">&nbsp;Sub Departments</router-link>
                   </li>
               </ol>
            </nav>
         </div>
         <div class="col-md-6">
            <button class="btn btn-primary float-right" v-b-modal.add-new-item><i class="fa fa-plus"></i>&nbsp;Departments</button>
         </div>
      </div>
      <div class="table-responsive ">
         <table class="table table-striped table-hover " v-loading="loading">
            <tbody>
               <tr v-for="item,i in departmentItem">
                  <template v-if="item === 'no data found'">
                     <td colspan="100%">
                        <h4>  <i class="fa fa-database"></i> Empty Records ...</h4>
                     </td>
                  </template>
                  <template v-else>
                     <td>
                        <a href="#" @click="get_selected_id(item)" class="link-default-departments" v-b-modal.update-deparment  v-b-tooltip.hover title="click to update department item and functionality"><u>{{item.department | capitalize}}</u></a>
                        <p><i>{{item.functionality | capitalize}}</i></p>
                     </td>
                     <td>
                        <h4><i class="fa fa-address-card-o"></i>&nbsp;&nbsp;Designations &nbsp;<span class="badge badge-pill badge-danger">{{item.disignations}}</span></h4>
                     </td>
                     <td>
                        <h4><i class="fa fa-user"></i>&nbsp;Employees <span class="badge badge-pill badge-danger">{{item.employee}}</span></h4>
                     </td>
                  </template>
               </tr>
            </tbody>
         </table>
      </div>
      <!-- MODAL FOR ADD NEW ITEM -->
      <b-modal id="add-new-item" ref="add-new-department"  size="l"   title="New Department"  hide-footer>
         <h3>Department</h3>
         <div class="form-group">
            <label>Deparment Name:</label>
            <input type="text" class="form-control" v-model="department_name">
            <label>Functionality:</label>
            <textarea class="form-control"  rows="6" v-model="functionality"></textarea>
         </div>
         <div class="form-group">
            <button class="btn btn-info float-right" @click="add_departments"><i class="fa fa-save"></i> Submit form</button>
         </div>
      </b-modal>
      <!-- MODAL FOR UPDATE RECORD  -->
      <b-modal id="update-deparment" ref="hide-department"  size="l"   title="Update Item"  hide-footer>
         <h3>Department</h3>
         <div class="form-group">
            <label>Deparment Name:</label>
            <input type="text" class="form-control" v-model="selected_item.department">
            <label>Functionality:</label>
            <textarea class="form-control" rows="6" v-model="selected_item.functionality"></textarea>
         </div>
         <div class="form-group">
            <button class="btn btn-info float-right" @click="update_departments"><i class="fa fa-save"></i> Save Changes</button>
         </div>
      </b-modal>
      <!-- If Lost Connection on Server -->   
      <template v-if="display_indicator === 1">
         <center>
            <br/><br/>
            <img  src="/static/img/warning.png"  width="225" height="190">
            <h1>You've lost your network connection</h1>
            <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
            <br/><br/>
         </center>
      </template>
   </card>
</template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'  
export default {
  components: {
    Card
  },
  data() {
    return {
      items: [],
      department_name: "",
      functionality: "",
      selected_item: "",
      loading: true,
      display_indicator: ""
    };
  },

  mounted: function() {
    this.get_departments();
  },

  methods: {
  
    get_departments() {
      axios
          .get("api/departments")
        .then(response => {
          this.items = response.data;
          this.display_indicator = 2;
          this.loading = false;
  
        })
        .catch(e => {
          console.log(e.response);
          this.display_indicator = 1;
        });
    },

    add_departments() {
      axios
        .post(
          "api/departments/add",
          {
            department_name: this.department_name,
            functionality: this.functionality
          }
        )
        .then(resp => {
            if(resp.data.response == "success"){
                this.$swal({
                    type: "success",
                    title: "Save",
                    text: resp.data.message,
                    showConfirmButton: true,
                    timer: 2000
                  });
                this.department_name = "";
                this.get_departments();
                this.$refs["add-new-department"].hide();
            }else if(resp.data.response == "error"){
                this.$swal({
                  type: "error",
                  title: "Error",
                  text: resp.data.message,
                  showConfirmButton: true,
                });
            }
          })
          .catch(error => {
            console.log(error);
          });
    },

    get_selected_id(item) {
      this.selected_item = item;
    },

    update_departments() {
      axios
        .post("api/departments/update/" + this.selected_item.dep_id,
          {
             department_name: this.selected_item.department,
             functionality: this.selected_item.functionality
          }
        )
        .then(response => {
            this.$swal({
              type: "success",
              title: "Save",
              text: "You successfully save",
              showConfirmButton: true,
              timer: 2000
            });
            this.department_name = "";
            this.get_departments();
            this.$refs["hide-department"].hide();
            console.log(response.data);
        })
        .catch(e => {
          console.log(e.response);
        });
    }
  },
  computed: {
    departmentItem() {
      let filterd = this.items;
      if (filterd.length > 0) {
        filterd.slice().reverse();
      }
      return filterd;
    }
  },

};
</script>
<style>
       .fa-update{
          color:#07b22c;
          font-size:19px;
        }
        .link-default-departments{
           color: #666;
           font-size: 25px;
           font-weight: 500;
           line-height: 1.1;
        }
        .bg-breadcrum{
            background:#fff;
         }
</style>     
        


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-departments/todo-department.vue